/* ============================================================
   LUXEA — Página de producto
   Selector visual de color (8 swatches) que cambia la imagen,
   selector de cantidad y soporte de variantes / propiedades.
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-product]').forEach(initProduct);

  function initProduct(root) {
    const form = root.querySelector('[data-product-form]');
    const mainImg = root.querySelector('[data-product-image]');
    const idInput = form && form.querySelector('[name="id"]');
    const colorProp = form && form.querySelector('[data-color-prop]');
    const colorLabel = root.querySelector('[data-color-name]');
    const priceEl = root.querySelector('[data-product-price]');
    const addBtn = form && form.querySelector('[data-add-btn]');

    // Datos de variantes inyectados por Liquid (puede estar vacío)
    let variantMap = {};
    try {
      const dataEl = root.querySelector('[data-variant-json]');
      if (dataEl) variantMap = JSON.parse(dataEl.textContent || '{}');
    } catch (e) { variantMap = {}; }

    const swatches = root.querySelectorAll('[data-swatch]');

    function selectColor(swatch) {
      const handle = swatch.getAttribute('data-swatch');
      const conf = (window.LuxeaColorMap && window.LuxeaColorMap[handle]) || {};
      const variant = variantMap[handle];

      // Imagen: usa la de la variante si existe, si no la del asset del tema
      const newImg = swatch.dataset.img || (variant && variant.image);
      if (newImg && mainImg) {
        mainImg.src = newImg;
        mainImg.style.opacity = '1';
      }

      // Estado activo
      swatches.forEach((s) => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      if (colorLabel) colorLabel.textContent = conf.name || swatch.getAttribute('data-name') || '';

      // Si hay variante real para este color -> seleccionarla
      if (variant && idInput) {
        idInput.value = variant.id;
        if (priceEl && variant.priceHtml) priceEl.innerHTML = variant.priceHtml;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? addBtn.getAttribute('data-label') : 'Agotado';
        }
      }

      // Siempre registrar el color como propiedad (estético) para mostrarlo en el carrito
      if (colorProp) colorProp.value = conf.name || swatch.getAttribute('data-name') || handle;
    }

let activeHoverImg = swatches[0] ? swatches[0].dataset.img || null : null;

    swatches.forEach((s) => {
  s.addEventListener('click', () => {
    selectColor(s);
    activeHoverImg = s.dataset.img || null;
  });
  s.addEventListener('mouseenter', () => {
    const hoverImg = s.dataset.img;
    if (hoverImg && mainImg) mainImg.src = hoverImg;
  });
  s.addEventListener('mouseleave', () => {
    if (activeHoverImg && mainImg) mainImg.src = activeHoverImg;
  });
});
    // Selecciona el primer swatch por defecto
    if (swatches.length) selectColor(swatches[0]);

    // Selector de cantidad
    const qty = form && form.querySelector('[name="quantity"]');
    if (qty) {
      const minus = form.querySelector('[data-qty-minus]');
      const plus = form.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }
  }
})();
